import React from "react";

import { People as PeopleIcon, Share as ShareIcon } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  Popover,
} from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import { MyFormFragment } from "@/gql/graphql";

type ModalProps = {
  data: MyFormFragment;
};

const useStyles = makeStyles()({
  container: {
    display: "flex",
    flexDirection: "column",
    padding: 8,
  },
  header: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

const StyledShareIcon = withStyles(ShareIcon, {
  root: {
    marginTop: 4,
    marginRight: 8,
    height: 12,
    width: 12,
  },
});

const StyledPeopleIcon = withStyles(PeopleIcon, {
  root: {
    marginRight: 4,
  },
});

const SentFormClientMenu: React.FC<ModalProps> = ({ data }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const { classes } = useStyles();
  const clientCount = data.sentTo.nodes.map((e) => e?.id).length;

  function handleOpen(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <>
      {data.sentTo.nodes.length > 0 && (
        <Box display="flex" onClick={handleOpen}>
          <StyledShareIcon color="primary" />
          <Typography variant="caption" color="textSecondary">
            {clientCount}
          </Typography>
        </Box>
      )}
      <Popover
        open={open}
        id={id}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        onClose={handleClose}
      >
        <div className={classes.container}>
          <Box className={classes.header}>
            <Typography variant="body1" color="textPrimary">
              Sent to
            </Typography>
            <Box display="flex" justifyContent="center" alignItems="center">
              <StyledPeopleIcon />
              {clientCount}
            </Box>
          </Box>
          <List>
            {data.sentTo.nodes.map((e) => (
              <ListItem disableGutters key={e.id}>
                <ListItemIcon>
                  <Avatar src={e?.profile?.avatarUrl ?? ""} />
                </ListItemIcon>
                <Box display="flex" flexDirection="column">
                  <Typography variant="body1" color="textPrimary">
                    {e?.profile?.fullName}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    {e?.email}
                  </Typography>
                </Box>
              </ListItem>
            ))}
          </List>
        </div>
      </Popover>
    </>
  );
};

export default SentFormClientMenu;
